module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (184).06da5446.jpg";